"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.TextBlockDefaultProps = exports.TextBlock = void 0;

var _textBlock = _interopRequireDefault(require("./components/text-block"));

exports.TextBlock = _textBlock["default"];

var _textBlock2 = _interopRequireDefault(require("./components/text-block.props/text-block.defaultProps"));

exports.TextBlockDefaultProps = _textBlock2["default"];